import React, { useContext, useState, useEffect } from 'react';
import '../style/ContactForm.css';
import { FormContext } from '../FormContext';

export default function ExchangeForm() {
  const { formData, updateFormData } = useContext(FormContext);
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  // Получаем email из localStorage при монтировании компонента
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        // Предполагаем, что в объекте user есть поле email
        setUserEmail(parsedUser.email || '');
      } catch (err) {
        console.error("Ошибка парсинга пользователя из localStorage", err);
      }
    }
  }, []);

  const handleNext = async () => {
    const newErrors = {};
    if (!formData.amount || Number(formData.amount) <= 0) newErrors.amount = 'Введите сумму обмена (больше 0)';
    if (!formData.telegram || !formData.telegram.trim()) newErrors.telegram = 'Укажите ваш Telegram';
    
    // Проверка наличия email (опционально, если это критично)
    if (!userEmail) {
      newErrors.server = 'Ошибка: Email пользователя не найден. Перезайдите в аккаунт.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});

    try {
      const resp = await fetch('https://bilpay.kg/api/exchange', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          amount: formData.amount, 
          currency: formData.currency, 
          telegram: formData.telegram,
          email: userEmail // ДОБАВЛЕНО: отправка email на бэкенд
        }),
      });

      const data = await resp.json();
      if (!resp.ok) {
        setErrors({ server: data.error || 'Ошибка отправки заявки' });
        return;
      }

      setErrors({});
      setSuccess('Ваш запрос успешно отправлен! Мы с вами через Telegram свяжемся.');
      setShowModal(true);
      
      updateFormData({ amount: '', currency: 'USD', telegram: '' });
      setTimeout(() => setShowModal(false), 4000);
    } catch (err) {
      setErrors({ server: 'Ошибка сети при отправке заявки' });
      console.error('exchange submit error', err);
    }
  };

  return (
    <div className="form-page">
      <div className="right-block">
        <div className="step-card">
          <h2 className="step-title">Заявка на обмен</h2>
          
          {/* Отображение email для информации пользователя (необязательно) */}
          {userEmail && (
            <p style={{ fontSize: '12px', color: '#666', textAlign: 'center', marginBottom: '15px' }}>
              Аккаунт: <strong style={{color: '#2563eb'}} >{userEmail}</strong>
            </p>
          )}

          <div className="input-group">
            <label>Сумма обмена</label>
            <input
              type="number"
              placeholder="1000"
              value={formData.amount}
              onChange={(e) => { updateFormData({ amount: e.target.value }); setErrors({ ...errors, amount: '' }); }}
              className={errors.amount ? 'input-error' : ''}
            />
            {errors.amount && <span className="error-text">{errors.amount}</span>}
          </div>

          <div className="input-group">
            <label>Валюта</label>
            <input
              type="text"
              placeholder="USD"
              value={formData.currency}
              onChange={(e) => updateFormData({ currency: e.target.value })}
            />
          </div>

          <div className="input-group">
            <label>Ваш Telegram</label>
            <input
              type="text"
              placeholder="@yourhandle"
              value={formData.telegram}
              onChange={(e) => { updateFormData({ telegram: e.target.value }); setErrors({ ...errors, telegram: '' }); }}
              className={errors.telegram ? 'input-error' : ''}
            />
            {errors.telegram && <span className="error-text">{errors.telegram}</span>}
          </div>
            <button className="next-btn" onClick={handleNext}>Отправить</button>
          {errors.server && <div className="error-text" style={{ marginTop: 12 }}>{errors.server}</div>}
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content">
            <div className="modal-icon">✅</div>
            <h3 className="modal-title">Успешно!</h3>
            <p className="modal-message">{success}</p>
            <button className="modal-close-btn" onClick={() => setShowModal(false)}>Закрыть</button>
          </div>
        </div>
      )}
    </div>
  );
}